<template>
<div class="page-inline-link mb-3">
   <a :href="link" :title="this.$props.nome" target="_blank">
      <svg class="icon icon-sm icon-primary mr-1">
         <use xlink:href="@/assets/img/sprite.svg#it-clip" v-if="type == 'doc'"></use>
         <use xlink:href="@/assets/img/sprite.svg#it-link" v-if="type != 'doc'"></use>
      </svg>
      <div>
         <b class="small">{{$props.nome}}</b>
         <span v-if="$props.extension">[{{$props.extension}}]</span>
      </div>
   </a>
</div>
</template>

<script>
export default {
   name: "linkBox",
   components:{
   },
   props: {
      type: {
        type: String,
        default: 'link',
        description: "Link type"
      },
      id: {
        type: String,
        description: "URL documento da scaricare"
      },
      nome: {
        type: String,
        description: "Nome del documento"
      },
      linkUrl: {
         type: String,
         description: "URL di destinazione o documento"
      },
   },
   computed:{
      link: function () {         
         if(this.$props.linkUrl){
            return this.$props.linkUrl;
         }
         else{
            return process.env.VUE_APP_URL+this.$props.id;            
         }
      }
   }
};
</script>